import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { async } from 'rxjs/internal/scheduler/async';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

export interface Service{
  service_title:string;
  service_image:string;
  service_description:string;
  service_overview:string;  
  service_dropdown:string;
  service_seoTitle:string;
  service_seoDes:string;
  service_iconUrl:string;
  id?: string;
}

@Component({
  selector: 'app-productdetails',
  templateUrl: './productdetails.component.html',
  styleUrls: ['./productdetails.component.css']
})
export class ProductdetailsComponent implements OnInit {

  id: any;
  servicedate: Observable<Service[]>;
  serviceDetails: any;

  constructor(private afs: AngularFirestore, private router: Router, private route: ActivatedRoute) {
    this.route.params.subscribe(params => {
      this.id = params['id'];
      console.log(this.id)

      if (this.id) {
        this.getSingleService(this.id).then(data => {
          data.subscribe(singleservice => {
            console.log(singleservice);
            this.serviceDetails = singleservice;
          });
        });
      }
    });
  }
  
  ngOnInit() {
  }

  
  async getSingleService(id) {
    const get = await this.afs.doc(`Service/${id}`);
    const getdata = await get.valueChanges();
    return getdata;
  }

}
